import React, { Component } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import Categories from "../../../../assets/creator/colorVariableCategories"
import BackButton from "../BackButton/BackButton"
import VariableSet from "./VariableSet/VariableSet"

import "./StyleMenuColorVariables.css"
import { getTranslation } from "../../../../assets/creator/translations"

class StyleMenuColorVariables extends Component {
	state = { currentSubcategoryName: null }

	selectSubcategory = subcategoryName => {
		if (this.state.currentSubcategoryName === subcategoryName) {
			this.setState({ currentSubcategoryName: null })
		} else {
			this.setState({ currentSubcategoryName: subcategoryName })
		}
	}

	render = () => (
		<React.Fragment>
			<BackButton onClick={this.props.onBackButtonPress}  />

			<CategoryMapper
				currentSubcategoryName={this.state.currentSubcategoryName}
				onSubcategorySelectHandle={this.selectSubcategory}
				onColorSelect={this.props.onColorSelect}
				colorSource={this.props.colorSource}
				containerRef={this.props.containerRef}
			>
			</CategoryMapper>
		
		</React.Fragment>
	)
}

export default StyleMenuColorVariables

const CategoryMapper = ({
	currentSubcategoryName,
	onSubcategorySelectHandle,
	onColorSelect,
	colorSource,
	containerRef,
}) =>
	Categories.map(cat => (
		<div className='variable-category' key={cat.key}>
			<div className='variable-category__name'>{getTranslation(cat.key)}</div>
			<VariableSet
				className='variable-category__variables'
				variables={cat.variables}
				onColorSelect={onColorSelect}
				colorSource={colorSource}
				containerRef={containerRef}
			/>
			<SubcategorySet
				className='variable-category__subcategories'
				currentSubcategoryName={currentSubcategoryName}
				subcategories={cat.subcategories}
				onSubcategorySelectHandle={onSubcategorySelectHandle}
				onColorSelect={onColorSelect}
				colorSource={colorSource}
				containerRef={containerRef}
			/>
		</div>
	))

const SubcategorySet = ({
	className,
	subcategories,
	currentSubcategoryName,
	onSubcategorySelectHandle,
	onColorSelect,
	colorSource,
	containerRef,
}) => {
	if (!Array.isArray(subcategories)) {
		return null;
	}
	return (
		<ul className={className}>
			{subcategories.map(sub => {
				const isCurrentSubcategory = currentSubcategoryName === sub.key;
				return (
					<li key={sub.key} className={`variable-subcategory`}>
						<SubcategoryDropdownControl
							subcategoryObject={sub}
							isCurrentSubcategory={isCurrentSubcategory}
							onSubcategorySelectHandle={onSubcategorySelectHandle}
						/>
						<VariableSet
							className='variable-subcategory__variables'
							variables={isCurrentSubcategory && sub.variables}
							onColorSelect={onColorSelect}
							colorSource={colorSource}
							containerRef={containerRef}
						/>
					</li>
				);
			})}
		</ul>
	);
}

const SubcategoryDropdownControl = ({
	isCurrentSubcategory,
	subcategoryObject,
	onSubcategorySelectHandle,
}) => {
	let chevronIcon;
	if (isCurrentSubcategory) {
		chevronIcon = faChevronUp;
	} else {
		chevronIcon = faChevronDown;
	}
	let chevronClass = "variable-subcategory__chevron ";
	if (isCurrentSubcategory) {
		chevronClass += "variable-subcategory__chevron--selected";
	} else {
		chevronClass += "variable-subcategory__chevron--not-selected";
	}

	return (
		<div
			className='variable-subcategory__control'
			onClick={() => onSubcategorySelectHandle(subcategoryObject.key)}>
			<span className='variable-subcategory__name'>
				{getTranslation(subcategoryObject.key)}
			</span>
			<FontAwesomeIcon
				icon={chevronIcon}
				className={chevronClass}
			/>
		</div>
	);
}
